<header class="bn-mobile-header">
  <button
    aria-controls="bn-sidebar-nav"
    class="bn-mobile-header__btn"
    data-e2e="DashboardMobileHeaderMenuButton"
    type="button"
    [attr.aria-expanded]="isMobileMenuOpened"
    [attr.aria-label]="isMobileMenuOpened ? 'Close menu' : 'Open menu'"
    [class.bn-mobile-header__btn--active]="isMobileMenuOpened"
    (click)="onToggleMenu()">
    <fa-icon
      aria-hidden="true"
      icon="bars" />
  </button>
  <a
    aria-label="Overview"
    class="bn-mobile-header__btn"
    data-e2e="DashboardMobileHeaderHomeLink"
    routerLink="/"
    routerLinkActive="bn-mobile-header__btn--active"
    [routerLinkActiveOptions]="{ exact: true }">
    <fa-icon
      aria-hidden="true"
      [icon]="['fad', 'house-blank']" />
  </a>
  <bn-dashboard-notifications
    class="ms-auto bn-mobile-header__notifications"
    data-e2e="DashboardMobileHeaderNotifications"
    [isMobile]="true" />
  <bn-layout-user-profile
    data-e2e="DashboardMobileHeaderUserProfile"
    [accountRoute]="accountRoute"
    [billingBalance]="billingBalance()"
    [billingRoute]="billingRoute"
    [email]="userEmail()"
    [fullName]="userFullName()"
    [isMobile]="true"
    [menuItems]="userProfileMenuItems()"
    [showBilling]="showBilling()"
    (logout)="onLogout()" />
</header>
